import React from 'react';

import Layout from './Layout';

function DashBoard() {
    return (
        <Layout className="App" showMenu>
            <div>
                <h1>Welcome</h1>
            </div>
        </Layout>
    );
}

export default DashBoard;


// WEBPACK FOOTER //
// ./src/components/DashBoard.js